import { StoreModel } from "../dali/vault-parser/parser.type";
import { StoreModelNames } from "@bitwarden/web-vault/app/services/dali/type/dali.type";
import { LogService } from "@bitwarden/common/abstractions/log.service";
import { StoreModelCollection } from "@bitwarden/web-vault/app/services/store/model.collection.abstraction";

export abstract class ModelStoreAbstraction {
  /** Store need implement Log **/
  protected abstract log: LogService;

  /** Store required method **/
  abstract clearStore(): void;
  abstract initialize(): void;

  protected abstract getStorageCollection(modelName: StoreModelNames): StoreModelCollection;

  /** Store shared method **/
  addStoreModels(modelName: StoreModelNames, data: StoreModel[]): void {
    const storeCollection = this.getStorageCollection(modelName);
    // This is the initial/full vault-load path (bootstrap + reloadFromVault), so an id already in the
    // map is a genuine duplicate, not an ordinary write-back re-set.
    storeCollection.loadModels(data, true);
  }
}
